// src/pages/About.js
import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './About.css';

const About = () => {
  useScrollReveal('.section');
  useScrollReveal('.card', true); // staggered reveal

  return (
    <main className="about-container">

      {/* Hero Banner */}
      <section className="section about-hero reveal">
        <div className="hero-content">
          <h1>About Talyfax</h1>
          <p>Empowering businesses through innovation, technology, and transformation.</p>
        </div>
      </section>

      {/* Company Story */}
      <section className="section about-section reveal">
        <h2>Our Story</h2>
        <p>
          Talyfax was founded to bridge the gap between businesses and modern technology.
          We specialize in software development, AI-driven solutions, and training bootcamps
          that empower individuals and organizations to thrive in the digital era.
        </p>
      </section>

      {/* Mission & Vision */}
      <section className="section about-grid reveal">
        <div className="card about-card reveal">
          <h3>Mission</h3>
          <p>
            Deliver scalable, impactful digital solutions that help businesses grow and adapt
            in a competitive landscape.
          </p>
        </div>
        <div className="card about-card reveal">
          <h3>Vision</h3>
          <p>
            Become a global leader in software innovation, inspiring change and transforming industries.
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="section about-section reveal">
        <h2>Our Values</h2>
        <ul className="about-values">
          <li><strong>Innovation</strong> — We push boundaries to create future-ready solutions.</li>
          <li><strong>Transparency</strong> — We build trust through clarity and integrity.</li>
          <li><strong>Collaboration</strong> — We grow through shared ideas and partnerships.</li>
        </ul>
      </section>

    </main>
  );
};

export default About;
